import Invoice from '../../FinalizedTemplates/InVoice';

const PrintableRecord = ({ schoolInfo, studentInfo, fees, isClassFee, templateId }) => (
    <div className="record-container" style={{ display: 'flex', flexDirection: 'row' }}>
        <Invoice schoolInfo={schoolInfo} studentInfo={studentInfo} fees={fees} isClassFee={isClassFee} templateId={templateId} />
    </div>
);

export default PrintableRecord;
